import { mapGetters } from "vuex";
import api from "@checkout/services/api";
import storage from "@checkout/services/storage";

export default {
    name: 'Tariff',

    data() {
        return {
            data: {},
            price: '',
            locale: 'en'
        }
    },

    computed: {
        ...mapGetters(['checkout']),
    },

    mounted() {
        this.getPresentationData();
        this.locale = storage.get('locale', true)
    },

    methods: {
        getPresentationData() {
            let tariff = this.checkout.type === 'TV Tariff' || this.checkout.type === 'Tv Device' ? this.checkout.tv_tariff : this.checkout.tariff;
            api.post('/public-api/get-presentation-of-tariff', {
                tariff: tariff,
                type: this.checkout.type === 'TV Tariff' || this.checkout.type === 'Tv Device' ? 'TV Tariff' : 'Tariff',
                binding: this.checkout.binding
            })
                .then((response) => {
                    this.data = response.data.body
                    this.price = response.data.price
                });
        }
    }
}
